// extracted by mini-css-extract-plugin
module.exports = {"results":"TokenList_results__21nY7"};